(function($) {

    $.shareable = {};

    $.shareable.init = function() {

        $('.shareable').click(function(e) {
          e.preventDefault();
          var href = $(this).attr('href');
          var w = 550;
          var h = 475;
          var l = (screen.width/2)-(w/2);
          var t = (screen.height/2)-(h/2);
          window.open(href, 'sharewindow', 'width='+ w +', height='+ h +', left='+ l +', top='+ t +', toolbar=0, menubar=0, directories=0, scrollbars=0');
        });

    };

    $(document).ready(function() {
        if ($('.shareable').length) {
            $.shareable.init();
        }
    });

})( jQuery );